<template>
  <router-view></router-view>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'App',
  async created() {
    await this.checkMerchantSource();
  },
  
  methods: {
    ...mapMutations(['setMerchantInfo']),
    async checkMerchantSource() {
      try {
        // 先从 Vuex 获取商户信息
        const storedMerchant = this.$store.getters.getSourceMerchant;
        
        
        
        
        const currentDomain = window.location.hostname;
        const data  = await this.$fetchs.request({
          url: this.$api.checkMerchant,
          method: 'POST',
          data: {domain: currentDomain}
        });
        if (data.is_sub_merchant) {
            this.setMerchantInfo(data.merchant);
            if(data.merchant.status == 0){
              // 显示授权过期弹窗，只显示图片
              // this.$alert('<div><img src="https://art-compass.oss-cn-beijing.aliyuncs.com/art_pc/images/home_zw.jpg" style="max-width: 800px; max-height: 600px;border-radius: 10px;"></div>', '', {
              //   dangerouslyUseHTMLString: true,
              //   showConfirmButton: false,
              //   closeOnClickModal: false,
              //   closeOnPressEscape: false,
              //   showClose: false,
              //   customStyle: {
              //     padding: '0',
              //     background: 'transparent',
              //     boxShadow: 'none',
              //     width: '800px',
              //     height: '600px',
              //     maxWidth: '90vw',
              //     maxHeight: '90vh'
              //   }
              // });

              // 显示授权过期弹窗，只显示文字
              this.$alert('<div style="display: flex; flex-direction: column; align-items: center; padding: 50px 30px; background: white; border-radius: 12px; box-shadow: 0 5px 25px rgba(0,0,0,0.08);"><div style="width: 50px; height: 50px; background: #fff3f0; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-bottom: 25px;"><span style="font-size: 24px; color: #ff6b35;">🔒</span></div><h2 style="color: #2c3e50; margin-bottom: 20px; font-size: 20px; font-weight: 500;">授权已过期</h2><p style="color: #7f8c8d; font-size: 15px; line-height: 1.6; text-align: center; max-width: 260px;">您的代理商授权已过期，请联系管理员处理相关事宜。</p></div>', '', {
                dangerouslyUseHTMLString: true,
                showConfirmButton: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showClose: false,
                customStyle: {
                  width: '350px',
                  background: 'transparent',
                  boxShadow: 'none',
                  border: 'none'
                }
              });
            }
        } else {
          this.setMerchantInfo([]);
        }
      } catch (error) {
        // 出错时清理本地存储
        this.setMerchantInfo([]);
      }
    }
  }
}
</script>

<style lang="scss">
//自定义confirmbtn按钮样式
.confirmbtn{
    color: #FFFFFF;
    background-color: #00BF67!important;
    border-color: #00BF67!important;
}
/* 自定义 ElMessageBox 的 confirm 按钮样式 */
.el-message-box__btns .el-button--primary {
    background-color: #00BF67!important; /* 背景颜色 */
    border-color: #00BF67!important; /* 边框颜色 */
    color: #FFFFFF; /* 文字颜色 */
}
// 全局背景颜色
body {
  background-image: url('https://art-compass.oss-cn-beijing.aliyuncs.com/art_pc/images/global-background.png'); /* 替换为你的背景图片路径 */
  background-size: cover; /* 使背景图片覆盖整个页面 */
  background-position: center; /* 使背景图片居中 */
  background-repeat: no-repeat; /* 防止背景图片重复 */
  margin: 0; /* 可选：移除默认的 body 边距 */
  padding: 0; /* 可选：移除默认的 body 内边距 */
}
.el-input{
  --el-input-focus-border-color:#00BD1E!important;
}
.el-select__wrapper.is-focused {
   box-shadow: 0 0 0 1px #00BF67 inset!important;
}
</style>